/// <amd-module name="Feed/Legacy/Protocols/Ivy/Commands/IvyDeleteCommand" />
import { IVssPageContext } from "VSS/Platform/Context";

import { Package } from "Feed/Common/Contracts/Feed";
import { IIvyRestClient } from "Feed/Common/Protocols/Ivy/RestClient/Ivy";
import * as PackageResources from "Feed/Common/Resources";
import { IFeedPerformanceService } from "Feed/Common/Services/FeedPerformanceService";
import { IError } from "Feed/Common/Types/IError";
import * as Actions from "Feed/Legacy/Actions/Actions";
import { IPackagePayload } from "Feed/Legacy/Common/ActionPayloads";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { IvyCiConstants, IvyPerfScenarios } from "Feed/Legacy/Protocols/Ivy/Constants/IvyConstants";
import { Feed, MinimalPackageVersion } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class IvyDeleteCommand {
    public static onDeletePackage(
        pageContext: IVssPageContext,
        packageSummary: Package,
        packageVersion: MinimalPackageVersion,
        feed: Feed,
        viaPackageList: boolean
    ): Promise<void> {
        const performanceService = pageContext.getService<IFeedPerformanceService>("IFeedPerformanceService");
        const scenario = performanceService.startScenario(IvyPerfScenarios.DeletePackage);

        CustomerIntelligenceHelper.publishEvent(pageContext, IvyCiConstants.DeletePackage, {
            feedId: feed.id,
            feedName: feed.name,
            viewId: feed.view ? feed.view.id : undefined,
            viewName: feed.view ? feed.view.name : undefined,
            packageName: packageSummary.name,
            packageVersion: packageVersion.version
        });

        return pageContext
            .getRestClient<IIvyRestClient>("IIvyRestClient")
            .packageDelete(feed.id, packageSummary.normalizedName, packageVersion.normalizedVersion)
            .then(
                success => {
                    packageVersion.isListed = false;
                    packageVersion.isDeleted = true;

                    const packagePayload = {
                        packageSummary,
                        packageVersion
                    } as IPackagePayload;

                    Actions.PackageModified.invoke(packagePayload);

                    if (viaPackageList) {
                        Actions.PackageListUpdated.invoke([]);
                    }

                    performanceService.endScenario(scenario);
                },
                err => {
                    performanceService.endScenario(scenario);
                    if (err.status === 401) {
                        Actions.ErrorEncountered.invoke({
                            message: PackageResources.Error_ErrorUserUnauthorized,
                            details: err
                        } as IError);
                    } else {
                        Actions.ErrorEncountered.invoke({
                            message: PackageResources.Error_ErrorDeletingPackage,
                            isCritical: true,
                            details: err
                        } as IError);
                    }
                }
            );
    }
}
